import { render, staticRenderFns } from "./detail_table.vue?vue&type=template&id=4afa34fa&scoped=true"
import script from "./detail_table.vue?vue&type=script&lang=js"
export * from "./detail_table.vue?vue&type=script&lang=js"
import style0 from "./detail_table.vue?vue&type=style&index=0&id=4afa34fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afa34fa",
  null
  
)

export default component.exports